import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
	AlertDialogTrigger,
} from '@/common/ui/alert-dialog'
import { Button } from '@/common/ui/button'
import useMutationDeleteReturnLoss from '@/modules/promotion/api/hooks/useMutateDeleteReturnLoss'
import { ReturnLossQueryKeys } from '@/modules/promotion/keys'
import { useQueryClient } from '@tanstack/react-query'
import { Trash2 } from 'lucide-react'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'

interface DeleteReturnLossProps {
	id: string
}

export const DeleteReturnLoss = ({ id }: DeleteReturnLossProps) => {
	const queryClient = useQueryClient()
	const { mutate: deleteReturnLoss } = useMutationDeleteReturnLoss({
		onSuccess: () => {
			toast.success('ลบค่าคอมมิชชั่นสำเร็จ')
			queryClient.invalidateQueries({
				queryKey: [ReturnLossQueryKeys.GetReturnLossList],
			})
		},
		onError: (error) => {
			showErrorToast(error)
		},
	})

	const handleDelete = () => {
		deleteReturnLoss({ id })
	}

	return (
		<AlertDialog>
			<AlertDialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Trash2 className="h-4 w-4 text-destructive" />
				</Button>
			</AlertDialogTrigger>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>ยืนยันการลบรายการคืนยอดเสีย</AlertDialogTitle>
					<AlertDialogDescription>
						การกระทำนี้ไม่สามารถย้อนกลับได้
						รายการคืนยอดเสียนี้จะถูกลบออกจากระบบอย่างถาวร
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<AlertDialogCancel>ยกเลิก</AlertDialogCancel>
					<AlertDialogAction onClick={handleDelete}>ลบ</AlertDialogAction>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
